import { Link, Stack, Typography, useTheme, Tile } from "@carrotfertility/carotene-core"
import React from "react"
import { FormattedMessage } from "react-intl"
import { DbgPaths } from "#/utils/Paths"
import { Link as ReactRouterLink } from "react-router-dom"

export default function DisclaimerTile({ isPro }: { isPro: boolean }): JSX.Element {
  const theme = useTheme()

  return (
    <Tile variant="secondary" color="primary" data-testid="disclaimer-tile">
      <Stack spacing={theme.spacing(theme.tokens.spacing.md)} alignItems="start">
        {isPro && (
          <Typography variant="body1" data-testid="carrot-funds-copy">
            <FormattedMessage
              defaultMessage="Carrot funds can only be used for products listed as eligible in <link>the benefit guide</link>."
              values={{
                link: (chunks) => (
                  <Link component={ReactRouterLink} color="inherit" to={DbgPaths.CARROT_ELIGIBLE}>
                    {chunks}
                  </Link>
                )
              }}
            />
          </Typography>
        )}
        <Typography variant="body1" fontStyle="italic">
          <FormattedMessage defaultMessage="External links lead to third-party websites governed by their own terms and privacy policies. Please review before providing any personal information. We may earn a commission on purchases made through these links."></FormattedMessage>
        </Typography>
      </Stack>
    </Tile>
  )
}
